import React from "react";

//UI Material
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Button,
  Card,
  Divider,
  Grid,
  Stack,
} from "@mui/material";

import { ExpandMore, Lock } from "@mui/icons-material";

//Helpers
import {
  typographyForCustomizedFontSize,
  typographyForMainTitles,
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";

export default function UserProfile({ userData }) {
  return (
    <Grid container spacing={1} alignItems="stretch">
      <Grid item md={6} xs={12}>
        <Card raised sx={{ height: "100%" }}>
          <Grid container sx={{ padding: "15px" }} spacing={1}>
            <Grid item xs={12} align="center">
              {typographyForSubtitles("Información General", "secondary")}
            </Grid>
            <Grid item xs={12}>
              {typographyForMainTitles(userData.user)}
            </Grid>
            <Grid item xs={12}>
              <Divider flexItem />
            </Grid>

            <Grid item xs={12} md={6}>
              <Stack
                alignItems="flex-start"
                justifyContent="flex-start"
                textAlign="left"
              >
                {typographyForCustomizedFontSize(
                  "Correo electrónico",
                  "11px",
                  null,
                  "bold"
                )}
                {typographyForText(userData.email, "bold")}
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                alignItems="flex-start"
                justifyContent="flex-start"
                textAlign="left"
              >
                {typographyForCustomizedFontSize(
                  "Cargo del usuario",
                  "11px",
                  null,
                  "bold"
                )}
                {typographyForText(userData.position, "bold")}
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                alignItems="flex-start"
                justifyContent="flex-start"
                textAlign="left"
              >
                {typographyForCustomizedFontSize(
                  "Fecha de registro",
                  "11px",
                  null,
                  "bold"
                )}
                {typographyForText(
                  new Date(userData.createdAt).toLocaleDateString(),
                  "bold"
                )}
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                alignItems="flex-start"
                justifyContent="flex-start"
                textAlign="left"
              >
                {typographyForCustomizedFontSize(
                  "Tipo de usuario",
                  "11px",
                  null,
                  "bold"
                )}
                {typographyForText(userData.role, "bold")}
              </Stack>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card raised>
          <Grid container sx={{ padding: "15px" }} spacing={1}>
            <Grid item xs={12} align="center">
              {typographyForSubtitles("Opciones de Configuración", "secondary")}
            </Grid>
            <Grid item xs={12} align="center">
              {typographyForText("Seleccionar la opción de configuración")}
            </Grid>
            <Grid item xs={12}>
              {/**Change password accordion */}
              <Accordion>
                <AccordionSummary
                  aria-controls="recover-password"
                  id="recover"
                  expandIcon={<ExpandMore />}
                >
                  <Stack
                    alignItems="flex-start"
                    justifyContent="flex-start"
                    textAlign="left"
                  >
                    {typographyForCustomizedFontSize(
                      "Cambiar contraseña",
                      "11px",
                      null,
                      "bold"
                    )}
                    {typographyForText("Reestablecer su contraseña")}
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Alert severity="info">
                        {typographyForText(
                          'Si deseas cambiar la contraseña de tu cuenta, podemos ayudarte a hacerlo. Presiona el botón "Cambiar Mi Contraseña" y sigue los pasos para cambiar tu contraseña.'
                        )}
                      </Alert>
                    </Grid>
                    <Grid item xs={12} align="center">
                      <Button
                        color="secondary"
                        variant="contained"
                        size="small"
                        sx={{ color: "white" }}
                        endIcon={<Lock />}
                        onClick={() => {
                          window.location.assign("/sendRecoverEmail");
                        }}
                      >
                        {"Cambiar mi contraseña"}
                      </Button>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              {/**Get help accordion */}
              <Accordion>
                <AccordionSummary
                  aria-controls="recover-password"
                  id="support"
                  expandIcon={<ExpandMore />}
                >
                  <Stack
                    alignItems="flex-start"
                    justifyContent="flex-start"
                    textAlign="left"
                  >
                    {typographyForCustomizedFontSize(
                      "¿Necesita más ayuda?",
                      "11px",
                      null,
                      "bold"
                    )}
                    {typographyForText("Información de soporte técnico")}
                  </Stack>
                </AccordionSummary>
              </Accordion>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}
